
export enum LogicalOperation {
  If = 22,
  Not = 23,
  Or = 24,
  And = 25, 
  Then = 26,
}

export enum MathematicalOperation {
  Add = 17,
  Subtract = 18, 
  Multiply = 19,
  Divide = 20,
}

export enum ComparisonOperation {
  Equals = 1,
  Eq = 2,
  NotEquals = 3,
  Neq = 4,
  GreaterThan = 5,
  GreaterThanOrEqual = 6,
  LessThan = 7,
  LessThanOrEquals = 8,
  Between = 9,
  IsEmpty = 15,
  IsNotEmpty = 16,
  IsNull = 36,
  IsNotNull = 37
}

export enum TextOperation {
  StartsWith = 11,
  Contains = 12,
  DoesNotContain = 13,
  EndsWith = 14,
  Concat = 10
}

export enum DateOperation {
  DateDiff = 32,
  DateAdd = 35
}

export enum FunctionOperation {
  Sum = 27,
  Avg = 28,
  Count = 29,
  Max = 30,
  Min = 31
}

export enum FormulaOperation {
  Equals = 1,
  Eq = 2,
  NotEquals = 3,
  Neq = 4,
  GreaterThan = 5,
  GreaterThanOrEqual= 6,
  LessThan = 7,
  LessThanOrEquals= 8,
  Between = 9,
  
  Concat = 10,
  StartsWith = 11,
  Contains = 12,
  DoesNotContain = 13,
  EndsWith= 14,
  IsEmpty = 15,
  IsNotEmpty = 16,
  
  Add = 17,
  Subtract = 18, 
  Multiply = 19,
  Divide = 20,
  
  If = 22,
  Not = 23,
  Then = 26,
  Or = 24,
  And = 25,

  Sum = 27,
  Avg = 28,
  Count = 29,
  Max = 30,
  Min = 31,
  
  DateDiff = 32,
  DateAdd = 35,

  IsNull = 36,
  IsNotNull = 37
}

export type LogicalOperationKey = keyof typeof LogicalOperation;
export type MathematicalOperationKey = keyof typeof MathematicalOperation;
export type ComparisonOperationKey = keyof typeof ComparisonOperation;
export type TextOperationKey = keyof typeof TextOperation;
export type DateOperationKey = keyof typeof DateOperation;
export type FunctionOperationKey = keyof typeof FunctionOperation;
export type FormulaOperationKey = keyof typeof FormulaOperation;

